<div>
  <app-breadcrumb></app-breadcrumb>
  <app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage"></app-notification-message>
  <h2 class="roboto title ms-4 me-4">Add Resolution</h2>
</div>

<!-- /////////////// -->

<div
class="px-3"
*ngIf="alertsuccessMessage != null"
class="alert alert-success alert-dismissible fade show p-2 ms-4 me-4"
role="alert"
>
<button
  type="button"
  class="btn-close"
  (click)="close()"
  data-bs-dismiss="alert"
  aria-label="close"
></button>
<strong>{{ alertsuccessMessage }}</strong>
</div>
<div
class="px-3"
*ngIf="alerterrorMessage != null"
class="alert alert-danger alert-dismissible fade show p-2 ms-4 me-4"
role="alert"
>
<button
  type="button"
  class="btn-close"
  (click)="close()"
  data-bs-dismiss="alert"
  aria-label="close"
></button>
<strong>{{ alerterrorMessage }}</strong>
</div>
<!-- ///////// -->

<div class="create-container mt-1">
  <div class="create-form-container ms-4 me-4">
    <div class="mat-typography content">
      <mat-accordion hideToggle multi>
        <mat-expansion-panel
          disabled
          [expanded]="true"
          #panel
          class="mat-elevation-z0"
        >
          <mat-expansion-panel-header class="header-container">
            <mat-panel-title class="roboto me-0 addEventTitle menuType" style="font-size: 20px !important;
            font-weight: 500;"
              >Add Resolution</mat-panel-title
            >
            <!-- <mat-icon class="toggleIcon">{{panel.expanded ? 'remove':'add'}}</mat-icon> -->
          </mat-expansion-panel-header>
          <form [formGroup]="addRouteEventForm" class="alignItem">
            <!--  ///////////////////////////////-->
            <div class="row d-flex flex-wrap my-3 align-items-start">
              <div class="col-md">
                <div class="row mb-3">
                  <div class="col-md-4 form-group required eventInput">
                    <label
                      class="col-lg-3 col-md-6 col form-group required control-label validRequired"
                      for="resolutionType"
                      >Resolution Type</label
                    >
                    <div class="d-block">
                      <select
                        class=""
                        id="resolutionType"
                        formControlName="resolutionType"
                        [ngClass]="{
                          'is-invalid': submitted && form['resolutionType'].errors
                        }"
                      >
                        <option value="">Please Select</option>
                        <option
                          *ngFor="let resolution of resolutionList"
                          [ngValue]="resolution"
                        >
                          {{ resolution.value }}
                        </option>
                      </select>
                      <div
                        *ngIf="submitted && form['resolutionType'].errors"
                        class="invalid-feedback"
                      >
                        <div *ngIf="form['resolutionType'].errors['required']">
                          Please Select the Resolution Type.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 form-group required eventInput">
                    <label
                      class="col-lg-3 col-md-6 col form-group required control-label validRequired"
                      for="plannedUnload"
                      >Status</label
                    >
                    <div class="d-block">
                      <select
                        class=""
                        id="status"
                        formControlName="status"
                        [ngClass]="{
                          'is-invalid': submitted && form['status'].errors
                        }"
                      >
                        <option value="">Please Select</option>
                        <option *ngFor="let st of statusList" [ngValue]="st">
                          {{ st.value }}
                        </option>
                      </select>
                      <div
                        *ngIf="submitted && form['status'].errors"
                        class="invalid-feedback"
                      >
                        <div *ngIf="form['status'].errors['required']">
                          Please Select the Status.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 form-group eventInput" *ngIf = "form['resolutionType'].value.label == 2 || form['resolutionType'].value.label == 3">
                    <label
                      class="col-lg-3 col-md-6 col control-label alignLabel"
                      for="reassignRouteName"
                      >Re Assign Route</label
                    >
                    <div class="d-block">
                      <input
                        class="form-control"
                        type="text"
                        name="reassignRouteName"
                        id="reassignRouteName"
                        formControlName="reassignRouteName"
                      />
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4 form-group required eventInput">
                    <label
                      class="col-lg-3 col-md-6 col form-group required control-label"
                      for="status"
                      >Load Number</label
                    >
                    <div class="d-block">
                      <input
                        class="form-control"
                        type="text"
                        name="loadNumber"
                        id="loadNumber"
                        formControlName="loadNumber"
                        [ngClass]="{
                          'is-invalid': submitted && form['loadNumber'].errors
                        }"
                      />
                      <div
                        *ngIf="submitted && form['loadNumber'].errors"
                        class="invalid-feedback"
                      >
                        <div *ngIf="form['loadNumber'].errors['required']">
                          Please enter the Route Name
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 form-group required eventInput">
                    <label
                      class="col-lg-3 col-md-6 col form-group required control-label"
                      for="destination"
                      >Destination</label
                    >
                    <div class="d-block">
                      <select
                        class=""
                        id="destination"
                        formControlName="destination"
                        [ngClass]="{
                          'is-invalid': submitted && form['destination'].errors
                        }"
                      >
                        <option value="">Please Select</option>
                        <option *ngFor="let st of destList" [ngValue]="st">
                          {{ st.value }}
                        </option>
                      </select>
                      <!-- <div
                        *ngIf="submitted && form['destination'].errors"
                        class="invalid-feedback"
                      >
                        <div *ngIf="form['destination'].errors['required']">
                          Please Select the Problem Type.
                        </div>
                      </div> -->
                    </div>
                  </div>
                  <div class="col-md-4 form-group required eventInput">
                    <label
                      class="col-lg-3 col-md-6 col form-group required control-label alignLabel"
                      for="logisticsPartner"
                      >Logistics Partner</label
                    >
                    <div class="d-block">
                      <select
                        id="logisticsPartner"
                        formControlName="logisticsPartner"
                        [ngClass]="{
                          'is-invalid':
                            submitted && form['logisticsPartner'].errors
                        }"
                        class=""
                      >
                        <option value="">Please Select</option>
                        <option *ngFor="let st of lpList" [ngValue]="st">
                          {{ st.value }}
                        </option>
                      </select>
                      <div
                        *ngIf="submitted && form['logisticsPartner'].errors"
                        class="invalid-feedback"
                      >
                        <div
                          *ngIf="form['logisticsPartner'].errors['required']"
                        >
                          Please Select the Logistics Partner.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4 form-group eventInput">
                    <label
                      class="col-lg-3 col-md-6 col control-label"
                      for="etaDate"
                      >ETA Date</label
                    >
                    <div class="d-block">
                      <input
                        class="form-control"
                        type="date"
                        name="etaDate"
                        id="etaDate"
                        formControlName="etaDate"
                        (change) = "etaChange()"
                      />
                    </div>
                  </div>
                  <div class="col-md-4 form-group eventInput">
                    <label
                      class="col-lg-3 col-md-6 col control-label"
                      
                      >ETA Time</label
                    >
                    <div class="d-block">
                      <ngx-timepicker-field
                        formControlName="etaTime"
                        class="form-control timepicker"
                        [format]="24"
                        [defaultTime]="'00:00'"
                      ></ngx-timepicker-field>
                    </div>
                  </div>
                  <div class="col-md-4 form-group eventInput">
                    <label
                      class="col-lg-3 col-md-6 col control-label alignLabel"
                      for="logisticsPartnerName"
                      >Logistics Partner Name</label
                    >
                    <div class="d-block">
                      <input
                        class="form-control"
                        type="text"
                        name="logisticsPartnerName"
                        id="logisticsPartnerName"
                        formControlName="logisticsPartnerName"
                      />
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4 form-group eventInput">
                    <label
                      class="col-lg-3 col-md-6 col control-label"
                      for="pickUpDate"
                      >Pick Up Date</label
                    >
                    <div class="d-block">
                      <input
                        class="form-control"
                        type="date"
                        name="pickUpDate"
                        id="pickUpDate"
                        formControlName="pickUpDate"
                        (change) = "pickUpChange()"
                      />
                    </div>
                  </div>
                  <div class="col-md-4 form-group eventInput">
                    <label
                      class="col-lg-3 col-md-6 col control-label"
                      for="pickUpTime"
                      >Pick Up Time</label
                    >
                    <div class="d-block">
                      <ngx-timepicker-field
                        formControlName="pickUpTime"
                        class="form-control timepicker"
                        [format]="24"
                        [defaultTime]="'00:00'"
                      ></ngx-timepicker-field>
                    </div>
                  </div>
                  <div class="col-md-4 form-group eventInput">
                    <label
                      class="col-lg-3 col-md-6 col control-label alignLabel"
                      for="trailer"
                      >Trailer Number</label
                    >
                    <div class="d-block">
                      <input
                        class="form-control"
                        type="text"
                        name="trailer"
                        id="trailer"
                        formControlName="trailer"
                      />
                      <!-- <div *ngIf="submitted && form['plannedUnload'].errors" class="invalid-feedback">
                                              <div *ngIf="form['plannedUnload'].errors['required']">
                                                  Please Select the Severity Type.
                                              </div>
                                          </div> -->
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4 form-group eventInput">
                    <label
                      class="col-lg-3 col-md-6 col control-label"
                      for="dispatchDate"
                      >Plan Dispatch Date</label
                    >
                    <div class="d-block">
                      <input
                        class="form-control"
                        type="date"
                        name="dispatchDate"
                        id="dispatchDate"
                        formControlName="dispatchDate"
                        (change) = "PlanDispatchChange()"
                      />
                    </div>
                  </div>
                  <div class="col-md-4 form-group eventInput">
                    <label
                      class="col-lg-3 col-md-6 col control-label"
                      for="dispatchTime"
                      >Plan Dispatch Time</label
                    >
                    <div class="d-block">
                      <ngx-timepicker-field
                        formControlName="dispatchTime"
                        class="form-control timepicker"
                        [format]="24"
                        [defaultTime]="'00:00'"
                      ></ngx-timepicker-field>
                    </div>
                  </div>
                  
                </div>
                <div class="row mb-3">
                  <div class="col-md-4 form-group required eventInput">
                    <label
                      class="col-lg-3 col-md-6 col form-group control-label"
                      for="commentsInput"
                      >Comments<span
                        *ngIf="commentsRequired"
                        class="commentsReq"
                        >*</span
                      ></label
                    >
                    <div class="d-block">
                      <textarea
                        class="form-control"
                        name="commentsInput"
                        #myInput (input)="checkChange(myInput.value)"
                        id="commentsInput"
                        cols="30"
                        rows="4"
                        formControlName="commentsInput"
                        [ngClass]="{
                          'is-invalid':
                            submitted &&
                            form['commentsInput'].errors &&
                            commentsRequired
                        }"
                      ></textarea>
                      <div
                        *ngIf="
                          submitted &&
                          form['commentsInput'].errors &&
                          commentsRequired
                        "
                        class="invalid-feedback"
                      >
                        <div *ngIf="form['commentsInput'].errors['required']">
                          Please enter the comments.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 form-group required eventInput"></div>
                  <div class="col-md-4 offset-1 form-group eventInput action">
                    <button class="cancel me-3 roboto-bold" (click)="onCancel()"> CANCEL </button>
                    <button class="black-button me-3 roboto-medium " (click)="onSubmit()">SAVE</button>
                    
                    </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4">
                    <p id="charCounter1">  Character Limit: {{maxi-ldiv}} left</p>
                  </div>
                  </div>
              </div>
            </div>
            <!-- /////////////// -->
          </form>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
  <!-- <div
    class="create_footer d-flex justify-content-end align-items-center fixed-bottom"
  >
    <button class="cancel me-3 roboto" (click)="onCancel()">CANCEL</button>
    <button class="black-button me-3 roboto" (click)="onSubmit()">SAVE</button>
  </div> -->
</div>
